export default "__VITE_ASSET__VdICPzhH__"